import { FC } from 'react';

type CastleIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const CastleIcon: FC<CastleIconProps> = ({ width = 24, height = 24, ...rest }) => (
  <svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.4932 4H6.49805V7.5H17.4932V4Z" stroke="#394B6F" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M14.4948 22L13.995 17H9.99685L9.49707 22" stroke="#394B6F" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M15.9936 7.5H7.99715L5.99805 22H17.9927L15.9936 7.5Z" stroke="#394B6F" strokeWidth="1.5"/>
    <path d="M7.99707 4V2" stroke="#394B6F" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M11.9961 4V2" stroke="#394B6F" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M15.9941 4V2" stroke="#394B6F" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M16.8047 12.0078H20.4356C20.4852 12.0078 20.5273 12.0442 20.5345 12.0932L21.8252 20.847C21.9143 21.4509 21.4463 21.9929 20.8359 21.9929H17.3921" stroke="#394B6F" strokeWidth="1.5"/>
    <path d="M7.18556 12H3.55461C3.50504 12 3.46296 12.0363 3.45573 12.0854L2.16504 20.8392C2.07601 21.4431 2.54399 21.9851 3.15435 21.9851H6.59811" stroke="#394B6F" strokeWidth="1.5"/>
  </svg>
);
